/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */


// global 'mj' object with configuration and static media- & metadata-related definitions
// - some stuff will be added in s/d/page.html
// - some stuff will be added in js/widget.js

if( window.hasOwnProperty('mj') && window.mj ) {
	// eslint-disable-next-line
	console.log( {
		'notice': 'page-mj.js: window.mj was already defined',
		'previous window.mj': window.mj,		//JSON.stringify(window.mj,null,'  ')
	} );

	// // eslint-disable-next-line
	// console.log({'previous window.mj': JSON.stringify(window.mj,null,'  ')});

	throw new Error('page-mj.js: window.mj was already defined');
}

// console.trace('initializing window.mj');

window.mj = {
	_add_debug_info: function( di ) {
		if( !window.mj.debug ) {
			window.mj.debug = di;
		} else {
			window.mj.debug.templates_rendered = window.mj.debug.templates_rendered ? [...window.mj.debug.templates_rendered,...di.templates_rendered] :  di.templates_rendered;
			window.mj.debug.styles_involved = window.mj.debug.styles_involved ? [...window.mj.debug.styles_involved,...di.styles_involved] : di.styles_involved;
		}
		if( window.mj.add_debug_info_hook ) window.mj.add_debug_info_hook(di);
	},

	mc_display_order: [
		1,4,3,2,6,8,7,0,	// image,text,audio,video,container,3d models,other,unknown
	],

	// list of meta-ids which should always be queried for rendering thumbnails
	required_thumbnail_meta_ids: [
		-4,						// modified-datetime
		-2,						// content-type
		-1,						// media-class
		//	  1,						// filename
		//	  3,						// id-string
		//	  5,						// filesize
		10, 11, 12,				// custom-preview-width, custom-preview-height, custom-preview-uploaded
		13,						// version-number
		49, 50, 51,				// expiry-datetime, advised-of-expiry-datetime, expired-datetime,
		52, 53,					// inception-datetime, incepted-datetime

		101,					// title
		200,201,				// image-width, image-height
		203,					// pixel-format
		229,					// image-rotation
		230,					// image-aspect-ratio-rotated
		231,					// image-is-animation
		233,					// photoshop-path-names
		234,					// photoshop-clip-path-index
		235,					// image-transparency
		237,					// image-boxes
		238,						// image-use-box
	],

	// ----------------------------------------
	// data added on DOMContentLoaded:
	// ----------------------------------------

	//  media.factories.js:
	//   - mc_ns = { 0: .., 7: .. }	- map of media_class to MC* (with methods createThumbnail(), createPreview(), ...)

	//  page-util.js:
	//   - mc_names = { 0: .., 7: .. } - media class names



	fixAssetURL: function( src ) {
		return src;
	},
	fixAssetURLSet: function( srcset ) {
		return srcset;
	},
	fixAssetURLsOnElement: function( elem ) {
	},

	fixJsonURL: function( url ) {
		return url;
	},

};

let mj = window.mj;

export {
	mj
};
